import Vue       from "vue";

Vue.filter("tzoffset", function (offset) {
  var sign = offset >= 0 ? '+' : '-';
  offset = Math.abs(offset) + '';
  if (offset.length === 1) offset = '0' + offset;
  return `${sign}${offset}:00`;
});



// WEBPACK FOOTER //
// ./src/filters/tzoffset.filter.js